module.exports = __webpack_public_path__ + "static/media/upe_named_white.28a6609f.svg";